import React from 'react';
import logo from '../logo.svg';
import './App.css';
import Menu from '../Menu/Menu'
import Footer from '../Footer/Footer'
import {Link} from 'react-router-dom'
// import Carousel from '../Carousel/Carousel'
import DemoCarousel from '../Carousel/Carousel'
import ServicesSection from '../ServicesSection/ServicesSection'

//CarouselPictures
import LisaPic from '../Images/Lisa.jpg'
import CrystlePic from '../Images/Crystle.png'
import RandomFamily from '../Images/random-family.jpg'

//example pictures
import ApparelPic from '../Images/Apparel.jpg'
import CanvasPic from '../Images/Canvas.jpg'
import DecorationsPic from '../Images/Decorations.png'
import DrinkwarePic from '../Images/Drinkware.png'
import AccessoriesPic from '../Images/Accessories.png'
import PuzzlesPic from '../Images/Puzzles.png'

//services picture
import ServicesPic from '../Images/Services.jpg'


function App() {
  return (
    <div className="App">

      <Menu />

      <div className='BodyContent'>

        <div className='ProductExamplesSection'>
          <div className='SectionTitle'><b>We</b> make the <span>canvas</span>, <b>you</b> paint the <span>picture</span>!</div>
          <div className='SectionSubtitle'>
            Caigoy Creations is a family-run business that can take your creation and bring it to life. We provide printing services on almost every surface.
          </div>
        </div>

        <div className='ExamplesSection'>
          <div className='Row'>
            <div className='ProductExample'>
              <span className='Title'>Apparel</span>
              <img className='Image' src={ApparelPic} />
            </div>

            <div className='ProductExample'>
              <span className='Title'>Canvas Prints</span>
              <img className='Image' src={CanvasPic} />
            </div>

            <div className='ProductExample'>
              <span className='Title'>Decorations</span>
              <img className='Image' src={DecorationsPic} />
            </div>
          </div>

          <div className='Row'>
            <div className='ProductExample'>
              <span className='Title'>Drinkware</span>
              <img className='Image' src={DrinkwarePic} />
            </div>

            <div className='ProductExample'>
              <span className='Title'>Accessories</span>
              <img className='Image' src={AccessoriesPic} />
            </div>

            <div className='ProductExample'>
              <span className='Title'>Jigsaw Puzzles</span>
              <img className='Image' src={PuzzlesPic} />
            </div>
          </div>
        </div>

        <ServicesSection />

      </div>


      <Footer />


    </div>
  );
}

export default App;
